var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.value !== null)?[_vm._v(_vm._s(_vm.imodel.fields[_vm.name].model.formatView(_vm.value)))]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }